/* Testimonios: una tarjeta por avance, respetando la reproducción elegida.
   Se reutilizan las flechas y el movimiento del carrusel de la tienda. */
(function () {
  'use strict';
  if (window.__miSocialAutoplay) return;
  window.__miSocialAutoplay = true;
  var montadas = new WeakSet();
  var PAUSA_MANUAL = 8000;

  function montar(seccion) {
    if (montadas.has(seccion)) return;
    var riel = seccion.querySelector('[data-mi-riel]');
    var siguiente = seccion.querySelector('[data-mi-next]');
    if (!riel || !siguiente) return;
    montadas.add(seccion);

    var intervalo = parseInt(seccion.getAttribute('data-mi-social-autoplay'), 10) || 6000;
    var temporizador = null;
    var visible = !window.IntersectionObserver;
    var interactuando = false;
    var hasta = 0;
    var movimiento = window.matchMedia('(prefers-reduced-motion: reduce)');

    function viendoVideo() {
      return Array.prototype.some.call(riel.querySelectorAll('.mi-sp__slot:not([hidden]) [data-mi-vp].is-activo video'), function (video) {
        return !video.paused && !video.ended && !video.error;
      });
    }
    function detener() {
      window.clearTimeout(temporizador);
      temporizador = null;
    }
    function programar(espera) {
      detener();
      if (!seccion.isConnected || !visible || interactuando || movimiento.matches || document.hidden || viendoVideo()) return;
      if (riel.scrollWidth <= riel.clientWidth + 4) return;
      temporizador = window.setTimeout(avanzar, Math.max(espera == null ? intervalo : espera, hasta - Date.now()));
    }
    function avanzar() {
      temporizador = null;
      if (!visible || interactuando || movimiento.matches || document.hidden || viendoVideo()) return;
      /* La navegación de teclado no debe perder el control que está usando. */
      if (riel.querySelector(':focus-visible')) {
        programar(intervalo);
        return;
      }
      var maximo = Math.max(0, riel.scrollWidth - riel.clientWidth);
      if (maximo < 4) return;
      var tarjetas = riel.querySelectorAll('.mi-sp__slot:not([hidden])');
      var ultima = tarjetas[tarjetas.length - 1];
      /* El encaje nativo puede detenerse antes del padding final. Si la
         última tarjeta ya se ve completa, el siguiente paso vuelve al inicio. */
      var finalVisible = ultima && ultima.getBoundingClientRect().right <= riel.getBoundingClientRect().right + 1;
      if (riel.scrollLeft >= maximo - 4 || finalVisible) riel.scrollTo({ left: 0, behavior: 'smooth' });
      else siguiente.click();
      programar(intervalo);
    }
    function interactuar(evento) {
      /* Los clics del reloj no cuentan como actividad del comprador. */
      if (evento && evento.type === 'click' && !evento.isTrusted) return;
      hasta = Date.now() + PAUSA_MANUAL;
      programar(PAUSA_MANUAL);
    }
    seccion.addEventListener('click', interactuar);
    /* En captura también se detectan los gestos de la barra del reproductor. */
    seccion.addEventListener('pointerdown', function () {
      interactuando = true;
      detener();
    }, { capture: true, passive: true });
    function soltar() {
      if (!interactuando) return;
      interactuando = false;
      interactuar();
    }
    window.addEventListener('pointerup', soltar, { passive: true });
    window.addEventListener('pointercancel', soltar, { passive: true });
    seccion.addEventListener('keydown', interactuar, true);
    seccion.addEventListener('focusin', interactuar);
    seccion.addEventListener('wheel', interactuar, { passive: true });

    ['playing', 'pause', 'ended', 'error', 'volumechange'].forEach(function (tipo) {
      seccion.addEventListener(tipo, function (evento) {
        if (!evento.target.matches('video')) return;
        if (viendoVideo()) detener();
        else if (evento.target.closest('.is-activo')) interactuar();
        else programar();
      }, true);
    });
    document.addEventListener('visibilitychange', function () { programar(); });
    movimiento.addEventListener('change', function () { programar(); });
    new ResizeObserver(function () { programar(); }).observe(riel);
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entradas) {
        visible = entradas[0].isIntersecting;
        programar();
      }, { threshold: 0.15 }).observe(seccion);
    } else programar();
  }
  function montarTodas(raiz) {
    if (raiz.nodeType === 1 && raiz.matches('[data-mi-social-autoplay]')) montar(raiz);
    raiz.querySelectorAll('[data-mi-social-autoplay]').forEach(montar);
  }
  function iniciar() {
    montarTodas(document);
    new MutationObserver(function (cambios) {
      cambios.forEach(function (cambio) {
        cambio.addedNodes.forEach(function (nodo) {
          if (nodo.nodeType === 1) montarTodas(nodo);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
